import React from "react";

import IntelligenceSensorItem from "./intelligenceSensorItem";

import styles from "./intelligenceSensorsList.module.scss";

const IntelligenceSensorsList = (props) => {
  const { data } = props;

  return (
    <div className={styles.intelligenceSensorsList}>
      {data.map((item, index) => {
        return (
          <div key={index}>
            <IntelligenceSensorItem title={item.title} value={item.value} measure={item.measure} />
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(IntelligenceSensorsList);
